module.exports = __webpack_public_path__ + "static/img/yellow_btn.2776f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zh-TW/yellow_btn.png
// module id = ZbmE
// module chunks = 0